import { Link, Text } from '@workos-inc/design-system';
import NextLink from 'next/link';
import type { PropDefinition } from 'src/components/props-table';
export const props: PropDefinition[] = [{
  name: 'accentColor',
  typeSimple: 'enum',
  type: toEnum(['gray', 'gold', 'bronze', 'brown', 'yellow', 'amber', 'orange', 'tomato', 'red', 'ruby', 'crimson', 'pink', 'plum', 'purple', 'violet', 'iris', 'indigo', 'blue', 'cyan', 'teal', 'jade', 'green', 'grass', 'lime', 'mint', 'sky']),
  default: '"indigo"',
  description: <>
        <Text>
          The dominant color of the theme. See the{' '}
          <Link asChild>
            <NextLink href="https://www.radix-ui.com/themes/docs/theme/color" rel="noopener noreferrer" target="_blank">
              Radix Themes color guide
            </NextLink>
          </Link>{' '}
          for more details.
        </Text>
      </>
}, {
  name: 'appearance',
  typeSimple: 'enum',
  type: '"inherit" | "light" | "dark"',
  default: '"inherit"',
  description: <Text>
        The color scheme of the theme. See the{' '}
        <Link asChild>
          <NextLink href="https://www.radix-ui.com/themes/docs/theme/dark-mode" rel="noopener noreferrer" target="_blank">
            Radix Themes dark mode guide
          </NextLink>
        </Link>{' '}
        for more details.
      </Text>
}, {
  name: 'fontFamily',
  typeSimple: 'string'
}, {
  name: 'grayColor',
  typeSimple: 'enum',
  type: toEnum(['auto', 'gray', 'mauve', 'slate', 'sage', 'olive', 'sand']),
  default: '"auto"',
  description: <Text>
        The grayscale palette of the theme. See the{' '}
        <Link asChild>
          <NextLink href="https://www.radix-ui.com/themes/docs/theme/color" rel="noopener noreferrer" target="_blank">
            Radix Themes color guide
          </NextLink>
        </Link>{' '}
        for more details.
      </Text>
}, {
  name: 'hasBackground',
  typeSimple: 'boolean',
  default: 'true',
  description: 'Whether to apply the themes background color to the theme node.'
}, {
  name: 'panelBackground',
  typeSimple: 'enum',
  type: '"solid" | "translucent"',
  default: '"translucent"',
  description: 'The background appearance of the theme’s panel components.'
}, {
  name: 'radius',
  typeSimple: 'enum',
  type: '"none" | "small" | "medium" | "large" | "full"',
  default: '"medium"',
  description: <Text>
        The radius of the theme’s components. See the{' '}
        <Link asChild>
          <NextLink href="https://www.radix-ui.com/themes/docs/theme/radius" rel="noopener noreferrer" target="_blank">
            Radix Themes radius guide
          </NextLink>
        </Link>{' '}
        for more details.
      </Text>
}, {
  name: 'scaling',
  typeSimple: 'enum',
  type: '"90%" | "95%" | "100%" | "105%" | "110%"',
  default: '"100%"',
  description: <Text>
        The linear scaling applied to the theme. See the{' '}
        <Link asChild>
          <NextLink href="https://www.radix-ui.com/themes/docs/theme/scaling" rel="noopener noreferrer" target="_blank">
            Radix Themes scaling guide
          </NextLink>
        </Link>{' '}
        for more details.
      </Text>
}];

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function toEnum(values: string[]) {
  return values.map(value => `"${value}"`).join(' | ');
}